import React, { useState, useEffect } from "react";
import Container from "../../components/Container";
import { InputPadrao, DatePickerPadrao, BtnPadrao, SemDados, LabelPadrao } from "../../components/Base";
import { Divider, Select, Tooltip } from "antd";
import * as api from "./api";
import { useFetch } from "../../components/Hooks/Conexao";
import PieGraphInd from "./PieGraphInd";
import InputOutlinedIcon from "@material-ui/icons/InputOutlined";
import PanToolOutlinedIcon from "@material-ui/icons/PanToolOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import moment from "moment";
import { RightOutlined } from "@ant-design/icons";
import DrawerFiltros from "../Shared/DrawerFiltros";
import styles from "./indicadores.module.scss";
import SelectFiltros from "../../components/SelectFiltros";
import { connect } from "react-redux";
import { logIn, fetch } from "../../actions/index";
import culture from './../../utils/Culture';
import SelectFabricantes from "../../components/SelectFabricantes";

const INITIAL_STATE = { mesAno: moment() };

function Indicadores(props) {
  const [dados, listarDados, loading] = useFetch(() => api.get(props.fetch, filtros));
  const [filtros, setFiltros] = useState(INITIAL_STATE);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    //listarDados();
  }, []);

  function checkDados() {
    if (dados) {
      var d = dados.indicadores;
      return d.participacao.fornecedorLoja.valorComparador || d.eficiencia.fornecedorLoja.valorComparador || d.penetracao.fornecedorLoja.valorComparador ? true : false;
    } else return false;
  }

  // if (loading && !dados) {
  //   return <Container loading={loading} path="indicadores"></Container>;
  // }

  return (
    <Container loading={loading} path="indicadores" large>
      <div style={{ display: "flex" }}>
        <div style={{ boxShadow: "0 0 10px #ddd", minWidth: 250, padding: 10, borderRadius: "20px", display: "flex", flexDirection: "column", justifyContent: "space-between", marginBottom: 20, height: "calc(100vh - 80px)" }}>
          <div style={{ overflow: "auto" }}>
            <DrawerFiltros filtros={filtros} setFiltros={setFiltros} visible={drawerVisible} onCancel={() => setDrawerVisible(false)} />
          </div>
        </div>
        <div style={{ flex: 1, margin: "0 20px" }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 10, marginTop: 10 }}>
            <SelectFabricantes style={{ minWidth: 200, marginRight: 10 }} value={filtros.fabricantes} onChange={v => setFiltros({ ...filtros, fabricantes: v })} mode="multiple" maxTagCount={2} />
            <div style={{ minWidth: 200, marginRight: 10 }}>
              <SelectFiltros modelo="setor" placeholder="Setor" value={filtros.setor} onChange={v => setFiltros({ ...filtros, setor: v })} mode="multiple" maxTagCount={2} />
            </div>
            <div style={{ minWidth: 200 }}>
              <SelectFiltros modelo="grupo" placeholder="Grupo" value={filtros.grupos} onChange={v => setFiltros({ ...filtros, grupos: v })} mode="multiple" maxTagCount={2} />
            </div>
            <DatePickerPadrao picker="month" value={filtros.mesAno} onChange={v => setFiltros({ ...filtros, mesAno: v })} style={{ margin: "0 10px" }} allowClear={false} />
            <BtnPadrao onClick={listarDados} type="primary" disabled={!filtros.mesAno}>
              Listar
            </BtnPadrao>
          </div>
          <div style={{ display: "flex", alignItems: "center", margin: "20px 0" }} className={styles.centro}>
            {checkDados() ? (
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "33%" }}>
                  <PieGraphInd
                    dados={{ id: 1, loja: dados.loja, fornecedor: dados.fornecedor, setor: dados.setor, porc: dados.indicadores.participacao, filtros: { ...filtros, filtro: "par" } }}
                    icon={<PanToolOutlinedIcon />}
                    title="Participação"
                    subTitle="Sell-Out / Faturamento"
                    tipo="pizza"
                  />
                </div>
                <div style={{ width: "33%", margin: "0 10px" }}>
                  <PieGraphInd
                    dados={{ id: 1, loja: dados.loja, fornecedor: dados.fornecedor, setor: dados.setor, porc: dados.indicadores.eficiencia, filtros: { ...filtros, filtro: "efi" } }}
                    icon={<InputOutlinedIcon />}
                    title="Eficiência"
                    subTitle="Sell-Out / Num Vendas"
                  />
                </div>
                <div style={{ width: "33%" }}>
                  <PieGraphInd
                    dados={{ id: 1, loja: dados.loja, fornecedor: dados.fornecedor, setor: dados.setor, porc: dados.indicadores.penetracao, filtros: { ...filtros, filtro: "pen" } }}
                    icon={<SettingsOutlinedIcon />}
                    title="Penetração"
                    subTitle="Sell-Out / M²"
                  />
                </div>
              </div>
            ) : (
              <SemDados style={{ margin: "0 auto" }} />
            )}
          </div>
        </div>

        {checkDados() && <div style={{ boxShadow: "0 0 10px #ddd", padding: 10, borderRadius: "20px", display: "flex", flexDirection: "column", justifyContent: "space-around", marginTop: 60, marginBottom: 20, }}>
          <div style={{ boxShadow: "0 0 10px #f1f1f1", borderRadius: "15px", height: "25%" }}>
            <h1 style={{ textAlign: "center", }}>Número de Lojas</h1>
            <Divider style={{ marginTop: 0 }} />
            <h2 style={{ textAlign: "center" }}>
              <span style={{ fontSize: 35, color: "#ff8000" }}>{dados.indicadores.painelLateral.lojasSelecionadas}</span>
              {/* <b style={{ fontSize: 35, color: "#666" }}>{dados.indicadores.painelLateral.lojas}</b> */}
              <span style={{ fontSize: 35, color: "#666" }}>/</span>
              <span style={{ fontSize: 35 }}>{dados.indicadores.painelLateral.lojasTotais}</span>
            </h2>
          </div>
          <div style={{ boxShadow: "0 0 10px #f1f1f1", borderRadius: "15px", height: "25%", margin: "10px 0", padding: 5 }}>
            <h1 style={{ textAlign: "center", }}>Sell-out</h1>
            <Divider style={{ marginTop: 0 }} />
            <h2 style={{ textAlign: "center", color: "#ff8000" }}>R$ {culture.format(dados.indicadores.painelLateral.vendas)}</h2>
            <h2 style={{ textAlign: "center" }}>R$ {culture.format(dados.indicadores.painelLateral.vendasRestante)}</h2>
          </div>
          <div style={{ boxShadow: "0 0 10px #f1f1f1", borderRadius: "15px", height: "25%", padding: 5 }}>
            <h1 style={{ textAlign: "center", }}>Número Vendas</h1>
            <Divider style={{ marginTop: 0 }} />
            <h2 style={{ textAlign: "center", color: "#ff8000" }}>{dados.indicadores.painelLateral.numVendas}</h2>
            <h2 style={{ textAlign: "center" }}>{dados.indicadores.painelLateral.numVendasRestantes}</h2>
          </div>
          <div style={{ boxShadow: "0 0 10px #f1f1f1", borderRadius: "15px", height: "25%", marginTop: 10, padding: 5 }}>
            <h1 style={{ textAlign: "center", }}>Metros Quadrados</h1>
            <Divider style={{ marginTop: 0 }} />
            <h2 style={{ textAlign: "center", color: "#ff8000" }}>{dados.indicadores.painelLateral.metrosQuad}</h2>
            <h2 style={{ textAlign: "center" }}>{dados.indicadores.painelLateral.metrosQuadRestantes}</h2>
          </div>
        </div>}

      </div>

    </Container >
  );
}

export default connect(null, { logIn, fetch })(Indicadores);
